module.exports = __webpack_public_path__ + "img/Events-News Silicon Valley Regional.ba84cb8a.png";